import {
  BOM_POSITION_ID,
  COMMUNITY_ID,
  END_DATE,
  START_DATE,
  STATUS,
  USER_IDS,
  BOM_USER_ID,
  USER_ID,
} from "./consts";
import { z } from "zod";

export const editBomSchema = z.object({
  [BOM_POSITION_ID]: z.string().min(1, "BM Position is required"),
  [START_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    }),
  [END_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !val || !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    })
    .optional(),
  [USER_IDS]: z.string().optional(),
  [COMMUNITY_ID]: z.string().optional(),
  [STATUS]: z.string().optional(),
  [BOM_USER_ID]: z.string().optional(),
  [USER_ID]: z.string().optional(),
});

export type editBomFormValues = z.infer<typeof editBomSchema>;
